import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center gap-2" }
const _hoisted_2 = { class: "leading-5" }

interface Props {
  /** Checklist item text */
  item: string
  /** Icon to display */
  icon?: string
  /** Icon color */
  color?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'CheckListItem'
},
  __name: 'CheckListItem',
  props: {
    item: {},
    icon: { default: '$check' },
    color: { default: 'success' }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_VIcon = _resolveComponent("VIcon")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createVNode(_component_VIcon, {
      color: __props.color,
      icon: __props.icon,
      size: "1.5rem",
      class: "p-1"
    }, null, 8, ["color", "icon"]),
    _renderSlot(_ctx.$slots, "default", { item: __props.item }, () => [
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.item), 1)
    ])
  ]))
}
}

})